// NOTE: Adds regular usercentrics event listeners to the window element
window.addEventListener('UC_UI_CMP_EVENT', (event) => {
  const eventType = event.detail.type;

  if (eventType === 'ACCEPT_ALL' || eventType === 'DENY_ALL' || eventType === 'SAVE') {
    window.location.reload();
  }
});
